module.exports = __webpack_public_path__ + "img/data-services.a25b9118.svg";